import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className = "", delay = 0.2 }) => (
  <span className={`block ${className}`}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
        <motion.span
          className="block"
          initial={{ y: "115%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.05, delay: delay + i * 0.16, ease: [0.22, 1, 0.36, 1] }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const Chapter = ({ index, label, className = "" }) => (
  <Reveal className={`flex items-center gap-4 ${className}`}>
    <span className="font-sans text-xs tracking-[0.3em] text-teal" data-testid={`chapter-${index}`}>{index}</span>
    <span className="h-px w-12 bg-teal/50" />
    <span className="font-sans text-xs uppercase tracking-[0.3em] text-white/50">{label}</span>
  </Reveal>
);
